// Generated by scripts/build-ui-icons.mjs.
export { PuzzlePiece as default } from "../ui/glyphs-6";
